module.exports = __webpack_public_path__ + "static/img/作品61.69be643.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品61.png
// module id = ppb7
// module chunks = 1